import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Asset } from '../../../model/asset';
import { AssetsService } from '../../../services/assets.service';
import { translate, TranslocoService } from '@ngneat/transloco';
import {SharedResource} from "../../../model/shared-resource";
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-assets-details',
  templateUrl: './assets-details.component.html',
  styleUrls: ['./assets-details.component.scss']
})
export class AssetsDetailsComponent implements OnInit {

  public navState: any;

  public asset: Asset;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  public sharedResources: Array<SharedResource> = [];
  public showDialog: boolean = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private assetsService: AssetsService,
              private translocoService: TranslocoService) {
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadAsset(params.uuid));

    this.translocoService.selectTranslate('common.new').pipe(take(1)).subscribe(() => {

      this.items = [
        {id: 'overview', label: translate('common.overview'), icon: 'pi pi-home'},
        {id: 'sensors', label: translate('model.sensors'), icon: 'pi pi-wifi'},
        {id: 'measures', label: translate('model.measures'), icon: 'pi pi-chart-bar'},
        {id: 'triggers', label: translate('model.triggers'), icon: 'pi pi-exclamation-triangle'},
        {id: 'events', label: translate('model.events'), icon: 'pi pi-exclamation-circle'},
        {id: 'devices', label: translate('model.devices'), icon: 'pi pi-mobile'},
        {id: 'technicalDetails', label: translate('attribute.technicalDetails'), icon: 'pi pi-file'},
      ];

      if (this.navState && this.navState.showView) {
        this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
        this.activeItem = this.items[this.activeItemIndex];
      } else {
        this.activeItemIndex = 0;
        this.activeItem = this.items[this.activeItemIndex];
      }

    })
  }

  loadAsset(assetUuid: string): void {
    this.assetsService.getAsset(assetUuid).subscribe(response => {
      this.asset = response.asset;
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  showSharedDialog(sharedResource: Asset): void {
    this.sharedResources = [new SharedResource('ASSET', sharedResource.alias, sharedResource.uuid,
      sharedResource.tenant.uuid, sharedResource.organization.uuid)];
    this.showDialog = true;
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

}
